import { render, staticRenderFns } from "./More.vue?vue&type=template&id=3ea16feb&"
import script from "./More.vue?vue&type=script&lang=js&"
export * from "./More.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports